/**
 * @ utility-ng-enumeration
 */
import Enumeration from 'utility-js-enumeration';

angular.module('utility-ng-enumeration', []).constant('Enumeration', Enumeration);

window['Enumeration'] = Enumeration;
export default Enumeration;



// WEBPACK FOOTER //
// ./app/vendor/utility-ng-enumeration/src/main.ts